import { toastInfo, toastWarning } from "../../toasts.js";
import { BaseWebComponent } from "../base-components/base-web-component.js";
import { BonusParamItemComponent } from "./bonus-param-item.js";

export class BonusParamItemGroupComponent extends BaseWebComponent {
    static webComponentName = 'bonus-parameters-group';
    constructor() {
        super();
        this.id = `bonus-parameters-group-${this.createRandomId()}`;
        this.globalListeners();
    }

    private globalListeners() {
        this.on('click', '[role="add-param-item"]', (event: Event) => {
            event.preventDefault();
            const newItem = this.addItem();
        });
        this.on<CustomEvent>('status-changed', 'bonus-param-item', (event: CustomEvent) => {
            const status = event.detail.status;
            this.classList.toggle('editing-children', this.isEditingParam);
        });
        this.addEventListener('param-changed', (event: Event) => {
            const ev: CustomEvent = event as CustomEvent;
            const current = ev.detail.value;
            if (current) {
                this.evalIncompleteItems();
            }
        });
        this.addEventListener('status-changed', (event: Event) => {
            event.stopPropagation(); // Evita che l'evento si propaghi ulteriormente
            const ev: CustomEvent = event as CustomEvent;
            const status = ev.detail.status;
            if(event.target instanceof BonusParamItemComponent) {
                const item = event.target as BonusParamItemComponent;
                console.log(`BonusParamItemGroupComponent: status-changed  to ${status}`);
                this.evalIncompleteItems();
            }
        });
        this.addEventListener('loaded-item', (event: Event) => {
            event.stopPropagation(); // Evita che l'evento si propaghi ulteriormente
            const ev: CustomEvent = event as CustomEvent;
            if (ev.detail && ev.detail.origin && ev.detail.origin.constructor.webComponentName === 'bonus-param-item') {
                this.evalIncompleteItems();
            }
        });
    }
    addItem(): BonusParamItemComponent | null {
        const tmpEl = document.createElement('div');
        tmpEl.innerHTML = `<bonus-param-item class="invalid" parameter-id="" value=""></bonus-param-item>`;
        const bonusParamItem = tmpEl.firstElementChild as BonusParamItemComponent;
        if (bonusParamItem == undefined) {
            toastWarning("Impossibile creare un nuovo parametro");
            return null;
        }
        this.querySelector('span.items-container')?.appendChild(bonusParamItem);
        tmpEl.remove();
        toastInfo("Nuovo parametro aggiunto");
        return bonusParamItem;
    }
    /**
    * Rimuove un elemento bonus-param-item dal gruppo
    * @param item - L'elemento da rimuovere
    * @returns true se l'elemento è stato rimosso, false altrimenti
    */
    removeItem(item: BonusParamItemComponent): boolean {
        const index = this.bonusParamItems.indexOf(item);
        if (index > -1) {
            item.remove();
            if (this.bonusParamItems.length === 0) {
                this.remove();
            }
            else {
                this.evalIncompleteItems();
            }
            return true;
        }
        return false;
    }
    private evalIncompleteItems(): void {
        const hasIncompleteItems = this.hasIncompleteItems;
        this.classList.toggle('has-incomplete-items', hasIncompleteItems);
        this.classList.toggle('complete-items', !hasIncompleteItems);
    }
    protected render(): void {
        // non c'è render su template
        console.log(this.bonusParamItems);
    }
    get isEditingParam(): boolean {
        return this.bonusParamItems.filter(item => item.status === 'edit').length > 0;
    }
    get hasIncompleteItems(): boolean {
        return this.bonusParamItems.some(item => item.status === 'edit' ||
            !item.value);
    }
    get bonusParamItems(): BonusParamItemComponent[] {
        return Array.from(this.querySelectorAll('bonus-param-item')) as BonusParamItemComponent[];
    }


}